import React, { useEffect, useRef } from 'react';
import { Platform, View, StyleSheet, Text } from 'react-native';

const ADSENSE_CLIENT_ID = process.env.EXPO_PUBLIC_ADSENSE_CLIENT_ID || '';
const ADSENSE_AD_SLOT_ID = process.env.EXPO_PUBLIC_ADSENSE_AD_SLOT_ID || '';

const AdSenseBanner = () => {
  const adContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (Platform.OS !== 'web' || !ADSENSE_AD_SLOT_ID || !ADSENSE_CLIENT_ID) {
      console.log('AdSense: Missing config or not on web');
      return;
    }

    const isLocalhost = window.location.hostname === 'localhost' ||
                        window.location.hostname === '127.0.0.1';

    // AdSense won't serve real ads on localhost - show placeholder instead
    if (isLocalhost) {
      console.log('AdSense: Running on localhost - ads will not load. Deploy to production to see real ads.');
      return;
    }

    console.log('AdSense: Initializing ad with client:', ADSENSE_CLIENT_ID, 'slot:', ADSENSE_AD_SLOT_ID);

    // Load AdSense script if not already loaded
    const existingScript = document.querySelector('script[src*="adsbygoogle.js"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT_ID}`;
      script.async = true;
      script.crossOrigin = 'anonymous';
      document.head.appendChild(script);
      console.log('AdSense: Script injected');
    }

    // Create and inject ad unit
    if (adContainerRef.current) {
      adContainerRef.current.innerHTML = `
        <ins class="adsbygoogle"
             style="display:block"
             data-ad-client="${ADSENSE_CLIENT_ID}"
             data-ad-slot="${ADSENSE_AD_SLOT_ID}"
             data-ad-format="auto"
             data-full-width-responsive="true"></ins>
      `;

      // Push to adsbygoogle after script loads
      setTimeout(() => {
        try {
          const win = window as any;
          win.adsbygoogle = win.adsbygoogle || [];
          win.adsbygoogle.push({});
          console.log('AdSense: Ad push completed');
        } catch (error) {
          console.error('AdSense push error:', error);
        }
      }, 100);
    }

    return () => {
      if (adContainerRef.current) {
        adContainerRef.current.innerHTML = '';
      }
    };
  }, []);

  if (Platform.OS !== 'web' || !ADSENSE_AD_SLOT_ID || !ADSENSE_CLIENT_ID) {
    return null;
  }

  // Check if localhost - show placeholder
  if (typeof window !== 'undefined' &&
      (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return (
      <View style={[styles.container, styles.placeholderContainer]}>
        <Text style={styles.placeholderTitle}>AdSense</Text>
        <Text style={styles.placeholderText}>
          Ads disabled on localhost{'\n'}Deploy to production to see real ads
        </Text>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <div
        ref={adContainerRef as any}
        style={{
          minHeight: 100,
          width: '100%',
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'center',
    paddingVertical: 10,
  },
  placeholderContainer: {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderRadius: 12,
    paddingVertical: 20,
    marginHorizontal: 12,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.1)',
    borderStyle: 'dashed',
  },
  placeholderTitle: {
    color: '#8D93B3',
    fontSize: 14,
    fontWeight: '700',
    marginBottom: 4,
  },
  placeholderText: {
    color: '#8D93B3',
    fontSize: 12,
    textAlign: 'center',
    lineHeight: 18,
  },
});

export default AdSenseBanner;
